import React from 'react';
import { Card, Button, Empty, Typography } from 'antd';
import { LoginOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph } = Typography;

const LoginRequired = ({ 
    title = "Login Required",
    message = "You need to be logged in to continue. Please login to continue.",
    returnPath = "/"
}) => {
    const navigate = useNavigate();

    return (
        <Card
            style={{
                borderRadius: 12,
                boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                border: '1px solid #f0f0f0',
                textAlign: 'center',
                padding: '60px 20px'
            }}
        >
            <Empty
                image={<LoginOutlined style={{ fontSize: 64, color: '#1890ff' }} />}
                description={
                    <div>
                        <Title level={4} style={{ marginBottom: 16 }}>
                            {title}
                        </Title>
                        <Paragraph type="secondary" style={{ fontSize: 16, marginBottom: 24 }}>
                            {message}
                        </Paragraph>
                        <Button
                            type="primary"
                            size="large"
                            icon={<LoginOutlined />}
                            onClick={() => navigate('/login', { state: { from: returnPath } })}
                            style={{
                                borderRadius: 8,
                                fontWeight: 600,
                                height: 44,
                                padding: '0 32px'
                            }}
                        >
                            Login to Continue
                        </Button>
                    </div>
                }
            />
        </Card>
    );
};

export default LoginRequired;

